// `sx` for a <Table> that hides the given columns (1-based positions) on phones,
// so the columns that matter fit without scrolling sideways. Only direct header
// and body cells are matched, so full-width rows (loading, empty, expanded
// detail) are unaffected.
export const hideColumnsOnPhone = (positions) => hideColumnsBelow(positions, "sm");

// Same, hiding below any breakpoint (e.g. "lg" for wide tables on laptops).
export const hideColumnsBelow = (positions, breakpoint) => ({
  [positions
    .map((n) => `& > thead > tr > th:nth-of-type(${n}), & > tbody > tr > td:nth-of-type(${n})`)
    .join(", ")]: {
    display: { xs: "none", [breakpoint]: "table-cell" },
  },
});
